import { message } from 'antd';
import { axios } from '../axiosInterceptor';
import { getEnvValue } from '../Environment';
import { getAPIUrl } from '../global';
import { Get, Post, Put, Remove } from '../headerIntercepter';
import { getAdminToken } from '../localStroageHandler';

export const getTechnology = (params) => {
  const url = getAPIUrl('globalApi.technology');
  return Get(url, false, params);
};

export const getKeySkill = (params) => {
  const url = getAPIUrl('globalApi.keyskill');
  return Get(url, false, params);
};
export const getLogo = (params={},query={}) => {
  const url = getAPIUrl('organization.logo',params);
  return Get(url, false, query);
};

export const getResume = async (resumeUrl) => {
  try {
      // const apiUrl = `${getEnvValue("REACT_APP_API_URL")}/api/download/resume/${resumeUrl}`;
      const apiUrl=resumeUrl
      const token = getAdminToken();

      const response = await axios.get(apiUrl, {
          responseType: "blob", // Necessary for downloading files
          // headers: {
          //     Authorization: `Bearer ${token}`, // Include token
          // },
      });

      // Create a blob URL for the downloaded file
      const blob = new Blob([response.data]);
      const downloadUrl = window.URL.createObjectURL(blob);

      // Trigger file download using an anchor element
      const link = document.createElement("a");
      link.href = downloadUrl;
      link.setAttribute("download", resumeUrl);
      document.body.appendChild(link);
      link.click(); // Trigger the download
      document.body.removeChild(link); // Clean up the DOM

      // Revoke the blob URL after the download
      window.URL.revokeObjectURL(downloadUrl);

      message.success("Resume downloaded successfully.");
  } catch (err) {
      console.error("Error downloading resume:", err);
      message.error("Failed to download the resume. Please try again later.");
  }
};
